<template>
    <div v-if="timer.isShowTimer">
        <p id="serial_timer">
            <span id="serial_label">{{lbl.expire_in}}</span><br>
            <span id="serial_timeleft" v-if="serialModel.expireIn != 0"
                :class="{'serial-expired': timer.isExpired}">
                {{timer.displayTime}}
            </span>
            <span id="serial_timeleft" v-if="serialModel.expireIn == 0">
                {{campaignExpire}}
            </span>
        </p>
    </div>
</template>
<script>
import TimerHelper from '@/helper/TimerHelper.js';
import DatetimeHelper from '@/helper/DatetimeHelper.js';

export default {
    name: 'SerialTimer',
    props: {
        lbl: Object,
        serialModel: Object,

        controller: Object
    },
    data: function () {
        return {
            timer: new TimerHelper(),
            campaignExpire: null,
        };
    },
    created: function () {
        this.initial();
    },
    methods: {
        initial: function () {
            console.log('time', this.serialModel);
            if(this.timer.interval)
                this.timer.stopTimer();

            this.timer.initialTimer(this.serialModel.expireIn);
            if (this.timer.isShowTimer)
                this.timer.runTimer(this.serialExpired);
            
            this.campaignExpire = DatetimeHelper.dateShortFormat(this.serialModel.expireDate);
        },
        serialExpired: function () {
            this.controller.cbSerialExpired.sendCallback();
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

#serial_timer {
    width: 100%;
    margin: {
        top: 3px;
        bottom: 3px;
    };
    //font
    font-size: 2rem;
    text-align: center;
    line-height: 0.9;

    #serial_label{
       color: $bright-gray; 
       font-size: 1.25rem;
    }
    #serial_timeleft {
        color: $pink;
        font-family: $medium;
        font-size: 1.5rem;

        &.serial-expired {
            color: $pink;
        }
    }
}
</style>
